// extracted by mini-css-extract-plugin
module.exports = {"label":"Form_label__15SAE"};